import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

import { Loading } from 'src/shared/components/loading/loading';
import { Client } from 'src/providers/client/client';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { Me } from 'src/providers/me/me';
import { TidyStorage } from 'src/shared/providers/tidy-storage';

import validationUtils from 'src/shared/util/validation-utils';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { Util } from 'src/shared/util/util';
import { Addresses } from 'src/providers/customer/addresses';

@Component({
    templateUrl: 'property-colors.html',
    standalone: false
})

export class PropertyColorsPage implements OnInit {

  form: UntypedFormGroup;
  dialogParams: any;
  isRightSideContent = true;
  loaded: boolean;
  submitted: boolean;
  addresses: any[] = [];


  boundSave = this.save.bind(this);

constructor(
    private client: Client,
    private fb: UntypedFormBuilder,
    private me: Me,
    private storage: TidyStorage,
    private navCtrl: CustomNavController,
    private rightSidePanelService: RightSidePanelService,
    private util: Util,
    private addressesProvider: Addresses
  ) {
    this.form = this.fb.group({});
  }

  async ngOnInit() {
    this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
    this.dialogParams = await this.storage.retrieve('dialog-params');
    this.rightSidePanelService.setDialogPageTitle('Property Colors');
    this.loadData();
  }

  @Loading('', true)
  async loadData() {
    try {
      this.rightSidePanelService.setDialogLoading(true);
      this.loaded = false;
      this.addresses = await this.getParam('addresses');
      const formGroup = {};
      this.addresses.forEach(address => {
        if (address && typeof address.id !== 'undefined') {
          formGroup[this.getIdString(address.id)] = [address.color || '', Validators.required];
        }
      });
      this.form = this.fb.group(formGroup);
      this.loaded = true;
      this.rightSidePanelService.setDialogLoading(false);
    } catch (err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message, 10000);
    }
  }

  async getParam(paramName): Promise<any> {
    let param = this.dialogParams?.[paramName];
    if (param === null || param === undefined) {
      param = this.navCtrl.getParam(paramName)
    }
    if (param === null || param === undefined) {
      param = await this.storage.retrieve(paramName);
    }
    this.storage.save(paramName, param);
    return param;
  }

  @Loading('', true)
  async save() {
    this.submitted = true;
    if (!this.form.valid) {
      return;
    }
    try {
      await Promise.all(this.addresses.map(address => {
        const newColor = this.form.get(this.getIdString(address.id)).value;
        if (newColor !== address.color) {
          const payload = {
            color: newColor
          }
          return this.addressesProvider.updateAddress(payload, address.id);
        }
      }));
      if (this.isRightSideContent) {
        this.rightSidePanelService.closeRightSidePanel();
      } else {
        this.navCtrl.back();
      }
      this.util.showSuccess('Colors successfully saved.');
    } catch (err) {
      this.util.showError((err.error && err.error.message) ? err.error.message : err.message, 10000);
    }
  }

  getIdString(id: any): string {
    return id?.toString() || '';
  }

}
